/**
 * Public permalink: /sport/:gameId – sport/game landing. Viewable without login.
 */

import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getPublicMatches } from '../../api/readApi';
import { getGameById } from '../../constants/games';
import PublicLayout from '../../components/PublicLayout';
import { useAuth } from '../../contexts/AuthContext';
import '../PublicPages.css';

export default function PublicSportPage() {
  const { gameId } = useParams();
  const { currentUser } = useAuth();
  const game = getGameById(gameId);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gameId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    getPublicMatches(gameId, null, 20)
      .then((res) => {
        if (cancelled) return;
        setMatches(res?.matches ?? []);
      })
      .catch(() => {
        if (!cancelled) setMatches([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [gameId]);

  if (!game) {
    return (
      <PublicLayout>
        <p>Sport not found.</p>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout title={`${game.icon} ${game.name}`}>
      <div className="public-card card-ui">
        <p className="public-desc">Public permalink for {game.name}. Share this page.</p>
        <nav className="public-nav-links">
          <Link to={`/sport/${gameId}/match`} className="public-link">Matches</Link>
        </nav>
        {currentUser && (
          <p className="public-logged-in">You are logged in. Full stats and features are available from Dashboard.</p>
        )}
      </div>
      <div className="public-card card-ui">
        <h2>Recent matches</h2>
        {loading ? (
          <p className="public-loading">Loading…</p>
        ) : matches.length === 0 ? (
          <p className="public-no-data">No matches yet.</p>
        ) : (
          <ul className="public-list">
            {matches.map((m) => (
              <li key={m.id}>
                <Link to={`/sport/${gameId}/match/${m.id}`} className="public-link">
                  Match {m.matchNumber != null ? `#${m.matchNumber}` : m.id.slice(0, 8)} · {m.status || 'scheduled'}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </PublicLayout>
  );
}
